"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _ActionStore2 = require("../../../higher-order/ActionStore");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _ApiGetter = _interopRequireDefault(require("../ApiGetter"));

var _stringFormat = _interopRequireDefault(require("string-format"));

var _class, _descriptor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var ContentStore = (_class = /*#__PURE__*/function (_ActionStore) {
  _inherits(ContentStore, _ActionStore);

  var _super = _createSuper(ContentStore);

  function ContentStore(props, dispatcher) {
    var _this;

    _classCallCheck(this, ContentStore);

    _this = _super.call(this, dispatcher);

    _initializerDefineProperty(_assertThisInitialized(_this), "content", _descriptor, _assertThisInitialized(_this));

    _this.apiGetter = new _ApiGetter.default(dispatcher);
    _this.content = _mobx.observable.map(props.content);
    _this.asyncContentViewModel = props.asyncContentViewModel;
    _this.extractContent = _this.createExtractContentFunction(_this.content);
    return _this;
  } // called on ActionRoot componentDidMount


  _createClass(ContentStore, [{
    key: "loadAsync",
    value: function loadAsync() {
      var _this2 = this;

      var self = this;

      if (!(0, _isEmpty.default)(this.asyncContentViewModel)) {
        this.apiGetter.fetch("/api/content?id=".concat(encodeURIComponent(this.asyncContentViewModel.contentName)), function (res) {
          self.content = _mobx.observable.map(res);
        }, function () {
          _clientErrorLogger.default.notify("Could not asynchronously load content", "warning", {
            asyncContentViewModel: _this2.asyncContentViewModel
          });
        });
      }
    }
  }, {
    key: "createExtractContentFunction",
    value: function createExtractContentFunction(content) {
      return function (contentKey, sharedKey, stringFormatArgs) {
        var outputContent;

        if (!(0, _isEmpty.default)(sharedKey)) {
          outputContent = content.has(sharedKey) ? content.get(sharedKey)[contentKey] : "";
        } else {
          outputContent = content.get(contentKey);
        }

        var isContentEmpty = (0, _isEmpty.default)(outputContent);

        if (!isContentEmpty && stringFormatArgs) {
          outputContent = (0, _stringFormat.default)(outputContent, stringFormatArgs);
        }

        return outputContent;
      };
    }
  }]);

  return ContentStore;
}(_ActionStore2.ActionStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "content", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ContentStore;